import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, NavigationConfirmPenaltyDecision, TransitRequestWFSteps, TransitCancelWorkflowSteps } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { Router } from '@angular/router';
import { MarineEstimatePenaltyComponent } from '../marine-estimate-penalty/marine-estimate-penalty.component';
import { NavigationConfirmPenaltyComponent } from '../navigation-confirm-penalty/navigation-confirm-penalty.component';

@Component({
  selector: 'app-penalty-finance-notification',
  templateUrl: './penalty-finance-notification.component.html',
  styleUrls: ['./penalty-finance-notification.component.css']
})
export class PenaltyFinanaceNotificationComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitCancelWorkflowSteps.FinanceNotification;
  PenaltyFinanaceNotificationForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  appInstanceId: string = '';
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  isLoaded: boolean = false;
  @ViewChild('navigationConfirmPenalty', { static: false }) navigationConfirmPenalty: NavigationConfirmPenaltyComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  stepData: any;
  @Input() isReadOnly: boolean = false;


  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
  ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.appInstanceId = history.state.data.appInstanceId;

      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm();
    if (this.isReadOnly) {
      this.PenaltyFinanaceNotificationForm.disable();
      this.formMode = FormMode.Readonly;
    } else {
      this.PenaltyFinanaceNotificationForm.enable();
    }
  }

  buildForm() {
    this.PenaltyFinanaceNotificationForm = this.formBuilder.group({

    });

  }

  get f() { return this.PenaltyFinanaceNotificationForm.controls; }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
        } else if (this.isReadOnly) {
          this.formMode = FormMode.Readonly;
        }
      }
    )
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.PenaltyFinanaceNotificationForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    //this.transitRequestCustomObj.IsVesselTransited = this.PenaltyFinanaceNotificationForm.controls['Decision'].value == NavigationConfirmPenaltyDecision.CONFIRM_PENALTY ? true : false;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.PenaltyFinanaceNotificationForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.navigationConfirmPenalty.marineEstimatePenalty.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;
    this.transitRequestCustomObj.AppInstanceId = this.appInstanceId;

    this.transitService.SubmitPenaltyFinanaceNotification(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.PenaltyFinanaceNotificationForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
